import { SxProps } from "@mui/material";

export const buttonSX: SxProps = {
    width:"20vw"
}